"use client";

import { usePageStore } from "@/app/zustand/usePageStore";
import { usePathname } from "next/navigation";

const ShowMoreNewsWrapper = ({ children }) => {
  const isDetailPage = usePageStore((s) => s.isDetailPage);
  const pathname = usePathname();

  if (!pathname) return null;

  // 🚫 restricted paths
  const restrictedPaths = ["/code-of-ethics-for-digital-news-websites"];

  if (restrictedPaths.includes(pathname)) {
    return null;
  }

  if (!isDetailPage) {
    return null;
  }

  return <>{children}</>;
};

export default ShowMoreNewsWrapper;
